import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function AboutSection() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const stats = [
    { icon: 'ri-user-line', value: '50,000+', label: t('happyCustomers', 'عملاء سعداء') },
    { icon: 'ri-global-line', value: '15+', label: t('cities', 'مدينة') },
    { icon: 'ri-speed-line', value: '99.9%', label: t('uptime', 'وقت التشغيل') },
    { icon: 'ri-award-line', value: '5+', label: t('yearsExperience', 'سنوات خبرة') }
  ];

  const tabs = [
    {
      title: t('ourMission', 'مهمتنا'),
      icon: 'ri-rocket-line',
      content: t('missionContent', 'نسعى لتوفير خدمات إنترنت عالية الجودة وبأسعار معقولة للمناطق النائية، مع التركيز على سهولة الوصول والدفع الآمن عبر وسائل متعددة تناسب جميع العملاء.')
    },
    {
      title: t('ourVision', 'رؤيتنا'),
      icon: 'ri-eye-line',
      content: t('visionContent', 'أن نكون الخيار الأول لخدمات الإنترنت في المناطق النائية، ونساهم في تقليص الفجوة الرقمية من خلال توفير اتصال موثوق وسريع للجميع.')
    },
    {
      title: t('ourValues', 'قيمنا'),
      icon: 'ri-heart-line',
      content: t('valuesContent', 'نؤمن بالشفافية، الجودة، والابتكار. نضع عملاءنا في المقام الأول ونعمل باستمرار على تحسين خدماتنا لتلبية احتياجاتهم المتطورة.')
    }
  ];

  return (
    <>
      <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-200/30 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-200/30 rounded-full blur-3xl translate-x-1/2 translate-y-1/2"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-6 py-2 rounded-full text-sm font-semibold">
                {t('aboutUs', 'من نحن')}
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              {t('aboutTitle', 'نربط المجتمعات بالعالم الرقمي')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              {t('aboutDesc', 'منصة رائدة في توفير خدمات الإنترنت للمناطق النائية مع حلول دفع مرنة وآمنة')}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-green-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="relative h-96 md:h-auto">
                <img
                  src="https://public.readdy.ai/ai/img_res/fe5b81f4e026b7fa097a4c1cdbed15cd.jpg"
                  alt="Team"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/50 to-transparent"></div>
              </div>
              
              <div className="p-12">
                <div className="flex gap-2 mb-8 border-b border-gray-200">
                  {tabs.map((tab, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveTab(index)}
                      className={`flex items-center gap-2 px-6 py-4 rounded-t-xl transition-all duration-300 whitespace-nowrap cursor-pointer ${
                        activeTab === index
                          ? 'bg-gradient-to-r from-blue-600 to-green-600 text-white shadow-lg'
                          : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                      }`}
                    >
                      <i className={`${tab.icon} text-xl`}></i>
                      <span className="font-semibold">{tab.title}</span>
                    </button>
                  ))}
                </div>

                <div className="animate-fade-in">
                  <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    {tabs[activeTab].content}
                  </p>
                  
                  <div className="flex flex-wrap gap-3">
                    <div className="flex items-center gap-2 bg-blue-50 px-4 py-2 rounded-full">
                      <i className="ri-check-line text-blue-600 text-xl"></i>
                      <span className="text-gray-700 font-medium">{t('reliable', 'موثوق')}</span>
                    </div>
                    <div className="flex items-center gap-2 bg-green-50 px-4 py-2 rounded-full">
                      <i className="ri-check-line text-green-600 text-xl"></i>
                      <span className="text-gray-700 font-medium">{t('secure', 'آمن')}</span>
                    </div>
                    <div className="flex items-center gap-2 bg-purple-50 px-4 py-2 rounded-full">
                      <i className="ri-check-line text-purple-600 text-xl"></i>
                      <span className="text-gray-700 font-medium">{t('fast', 'سريع')}</span>
                    </div>
                    <div className="flex items-center gap-2 bg-orange-50 px-4 py-2 rounded-full">
                      <i className="ri-check-line text-orange-600 text-xl"></i>
                      <span className="text-gray-700 font-medium">{t('affordable', 'بأسعار معقولة')}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <button
                onClick={() => setShowModal(true)}
                className="bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center gap-3"
              >
                <span>{t('learnMore')}</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        <style>{`
          .animate-fade-in {
            animation: fadeIn 0.5s ease-in;
          }
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
      </section>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-6 animate-fade-in" onClick={() => setShowModal(false)}>
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-scale-in" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-green-600 text-white p-8 rounded-t-3xl flex justify-between items-center z-10">
              <h3 className="text-3xl font-bold">{t('aboutUsDetails')}</h3>
              <button
                onClick={() => setShowModal(false)}
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all duration-300 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <div className="p-8 space-y-8">
              {/* Our Story */}
              <div className="space-y-4">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                    <i className="ri-book-open-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-800">{t('ourStory')}</h4>
                </div>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {t('ourStoryText')}
                </p>
              </div>

              {/* Our Mission */}
              <div className="space-y-4 bg-blue-50 p-6 rounded-2xl">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center">
                    <i className="ri-target-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-800">{t('ourMission')}</h4>
                </div>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {t('missionText')}
                </p>
              </div>

              {/* Our Vision */}
              <div className="space-y-4">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
                    <i className="ri-eye-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-800">{t('ourVision')}</h4>
                </div>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {t('visionText')}
                </p>
              </div>

              {/* Our Values */}
              <div className="space-y-4 bg-green-50 p-6 rounded-2xl">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center">
                    <i className="ri-heart-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-800">{t('ourValues')}</h4>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-2xl text-green-600 flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-gray-800 text-lg">{t('integrity')}</strong>
                      <p className="text-gray-600">{t('integrityText')}</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-2xl text-green-600 flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-gray-800 text-lg">{t('innovation')}</strong>
                      <p className="text-gray-600">{t('innovationText')}</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-2xl text-green-600 flex-shrink-0 mt-1"></i>
                    <div>
                      <strong className="text-gray-800 text-lg">{t('customerFirst')}</strong>
                      <p className="text-gray-600">{t('customerFirstText')}</p>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Team */}
              <div className="space-y-4">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl flex items-center justify-center">
                    <i className="ri-team-line text-2xl text-white"></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-800">{t('ourTeam')}</h4>
                </div>
                <p className="text-gray-600 leading-relaxed text-lg">
                  {t('ourTeamText')}
                </p>
              </div>

              <div className="pt-6 border-t border-gray-200">
                <button
                  onClick={() => setShowModal(false)}
                  className="w-full bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  {t('close')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scale-in {
          from { opacity: 0; transform: scale(0.9); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
        .animate-scale-in {
          animation: scale-in 0.3s ease-out;
        }
      `}</style>
    </>
  );
}
